import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

Vue.http.interceptors.push((request, next) => {
  console.log(request)
  request.params.access_token = '4543fd141b6af93a6cb8'
  request.credentials = true
  next()
})

const root = 'https://api.ansergy.com/email-reports'

let uniqueRequests = {}
function ensureUniqueRequest (token, request) {
  if (uniqueRequests[token]) {
    uniqueRequests[token].abort()
  }
  uniqueRequests[token] = request
}

function request (method, path, options) {
  options = Object.assign({}, options, {
    before: ensureUniqueRequest('email-reports')
  })

  return new Promise(function (resolve, reject) {
    const url = `${root}/${path}`
    Vue.http[method](url, options)
      .then((response) => {
        resolve(response.body)
      }, (response) => {
        console.error('error', response)
        reject(response)
      })
  })
}

function get (path, options) {
  return request('get', path, options)
}

function post (path, options) {
  return request('post', path, options)
}

export default { get, post, root }



// WEBPACK FOOTER //
// ./src/lib/api.js